
import { Routes, Route } from 'react-router-dom';
import './App.css';
import NavBar from './components/NavBar';
import HomePage from './pages/HomePage';
import Footer from './components/Footer';
import AboutPage from './pages/AboutPage';
import ScrollToTop from './components/ScrollTop';
import ContactPage from './pages/ContactPage';
import BlogCombine from './pages/BlogCombine';
import BlogDetail from './components/Blog/BlogDetail';
import ServicePage from './pages/ServicePage';
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from 'react';

function App() {
    useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100,
    });
  }, []);
  return (
    <div className="App font-quicksand">
      <ScrollToTop />
      <NavBar />
      <Routes>
        <Route path='/' element={<HomePage />} />
        <Route path='/about-me' element={<AboutPage />} />
        <Route path='/contact-me' element={<ContactPage />} />
        <Route path='/blogs' element={<BlogCombine />} />
        <Route path='/specialities' element={<ServicePage />} />
        <Route path='/blogs/:id' element={<BlogDetail />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;